import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BsRocketTakeoff } from 'react-icons/bs';

function PremiumPage() {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1); // Gå tillbaka till föregående sida
    };

    return (
        <div className='center pt-64 pb-64'>

            <h1 className='center pb-32'>Hold tight!</h1>
            <BsRocketTakeoff className="rocket-icon" />

            <h3>Just nu jobbet pågår för fullt.</h3>

            <div className='center p-16 pb-64' style={{ maxWidth: "500px" }}>
                <p>Kika gärna förbi lite senare för att ta del av exklusiva erbjudanden och utnytja alla funktioner till fullo som snart kommer!</p>
                <p className=''>Tack för ditt tålamod och att du är en del av vår gemenskap.</p>

                <button className='ghostbutton mt-32' style={{ maxWidth: 135 }}
                        onClick={handleBackClick}>
                    Gå tillbaka
                </button>
            </div>
        </div>
    );
}

export default PremiumPage;